"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPaginationItem = exports.getPageSequence = void 0;
const icons_1 = require("@components/icons");
const react_1 = __importDefault(require("react"));
const DOTS = "...";
const getPageSequence = (currentPage, totalPageCount, maxVisiblePageNumber) => {
    const pageControls = [];
    pageControls.push({ type: "arrow-left", value: currentPage - 1 > 0 ? currentPage - 1 : undefined });
    if (maxVisiblePageNumber + 2 < totalPageCount) {
        const pageVisibleDistance = Math.floor(maxVisiblePageNumber / 2);
        pageControls.push({ type: "page", value: 1 });
        if (currentPage - pageVisibleDistance - 1 > 0) {
            pageControls.push({ type: "dots" });
        }
        const startFromIndex = currentPage - pageVisibleDistance < 1 ? 2 : currentPage - pageVisibleDistance + 1;
        const endToIndex = currentPage + pageVisibleDistance > totalPageCount ? totalPageCount : currentPage + pageVisibleDistance;
        const pageNumberControls = Array(endToIndex - startFromIndex)
            .fill(1)
            .map((_, index) => ({ type: "page", value: index + startFromIndex }));
        pageControls.push(...pageNumberControls);
        if (currentPage + pageVisibleDistance + 1 < totalPageCount) {
            pageControls.push({ type: "dots" });
        }
        pageControls.push({ type: "page", value: totalPageCount });
    }
    else {
        const pageNumberControls = Array(totalPageCount)
            .fill(1)
            .map((_, index) => ({ type: "page", value: index + 1 }));
        pageControls.push(...pageNumberControls);
    }
    pageControls.push({ type: "arrow-right", value: currentPage + 1 <= totalPageCount ? currentPage + 1 : undefined });
    return pageControls;
};
exports.getPageSequence = getPageSequence;
const renderPaginationItem = (item, setPage) => {
    const { type, value } = item;
    const key = crypto.randomUUID();
    if (type === "page" && value) {
        return (react_1.default.createElement("div", { key: key, className: "c-grid-pagination__page", onClick: () => setPage(value) }, value));
    }
    else if (type === "arrow-left") {
        const arrowClasses = `c-grid-pagination__prev-page c-grid-pagination__prev-page--${!value ? "disabled" : ""}`;
        return (react_1.default.createElement("div", { key: key, onClick: () => value && setPage(value), className: arrowClasses },
            react_1.default.createElement(icons_1.ArrowDownIcon, { scale: 1, color: "grey" })));
    }
    else if (type === "arrow-right") {
        const arrowClasses = `c-grid-pagination__next-page c-grid-pagination__next-page--${!value ? "disabled" : ""}`;
        return (react_1.default.createElement("div", { key: key, onClick: () => value && setPage(value), className: arrowClasses },
            react_1.default.createElement(icons_1.ArrowDownIcon, { scale: 1, color: "grey" })));
    }
    else if (item.type === "dots") {
        return (react_1.default.createElement("div", { key: key, className: "c-grid-pagination__dots" }, DOTS));
    }
    return null;
};
exports.renderPaginationItem = renderPaginationItem;
